import React from "react";
import { Box, Divider, Stack, Typography, Button } from "digiwash-components";
import BoxRatio from "../BoxRatio";
import CustomIcon from "../CustomIcon";
import { boxRatioWidth } from "../../helpers/general";

interface ServerErrorType {
  action: () => void;
  error: string;
}

function ServerError(props: ServerErrorType) {
  return (
    <Stack distribution="center" direction="vertical">
      <BoxRatio
        fixedWidth={boxRatioWidth({
          columns: 1,
          padding: ["xxl", "xxl"],
        })}
        ratio="2:1"
      >
        <CustomIcon icon="serverError" width="100%" height="100%" />
      </BoxRatio>
      <Divider size="xxxl" />
      <Typography ff="mainBold" fs="l" color="common.black">
        {props.error}
      </Typography>
      <Divider size="m" />
      <Typography color="common.black">لطفا مجددا تلاش کنید.</Typography>
      <Divider size="xxxl" />
      <Box style={{ width: 224 }}>
        <Button onPress={() => props.action()} size="l">
          تلاش مجدد
        </Button>
      </Box>
    </Stack>
  );
}

export default ServerError;
